import React from 'react';
import { format, isValid } from 'date-fns';
import Button from '@material-ui/core/Button';
import { Input, Select, MenuItem } from '@material-ui/core';

import { DatePicker } from '../../Controls/DatePicker';
import { applicationKeysMap, InputType } from '../const';
import { parseDate } from '../../../utils/date';

import cn from "./ApplicationEditForm.module.scss";

export class ApplicationEditForm extends React.PureComponent {
  state = {
    application: null,
  };

  componentDidMount() {
    this.setState({
      application: this.props.application,
    });
  }

  handleTextInputChange = (event, key) => {
    const { value } = event.target;
    this.setState(state => ({
      application: {
        ...state.application,
        [key]: value,
      },
    }));
  };

  handleServiceAgencyChange = (event) => {
    const { value } = event.target;
    const agency = this.props.serviceAgencies.find(agency => agency.id === value);
    this.setState(state => ({
      application: {
        ...state.application,
        'service_agency_id': agency.id,
        'service_agency': agency.name,
      },
    }));
  };

  handleInsuranceAgencyChange = (event) => {
    const { value } = event.target;
    const agency = this.props.insuranceAgencies.find(agency => agency.id === value);
    this.setState(state => ({
      application: {
        ...state.application,
        'insurance_agency_id': agency.id,
        'insurance_agency': agency.name,
      },
    }));
  };

  handleDateChange = (date, key) => {
    this.setState(state => ({
      application: {
        ...state.application,
        [key]: isValid(date) ? format(date, 'yyyy-MM-dd') : date,
      },
    }));
  };

  handleSave = async () => {
    try {
      const newApplication = this.state.application;
      const { onEdit, onClose, application } = this.props;
      await onEdit(newApplication, application);
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const { application } = this.state;
    const { onClose, insuranceAgencies, serviceAgencies } = this.props;
    return (
      <div>
        <div className={cn.form}>
          {application && Object.keys(applicationKeysMap)
            .filter((key) => application[key] !== undefined)
            .map((key) => {
              const { type, editable, clearable, label, options } = applicationKeysMap[key];
              return (
                <div key={key} className={cn.row}>
                  <div className={cn.label}>{label}:</div>
                  {editable ? (
                    <div className={cn.value}>
                      {type === InputType.TEXT && (
                        <Input
                          value={application[key]}
                          onChange={(event) => this.handleTextInputChange(event, key)}
                          classes={{
                            root: cn.input,
                          }}
                          fullWidth
                        />
                      )}
                      {type === InputType.SELECT && (
                        <Select
                          value={application[key] || ''}
                          onChange={(event) => this.handleTextInputChange(event, key)}
                          className={cn.select}
                        >
                          {options && options.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                          ))}
                        </Select>
                      )}
                      {type === InputType.DATE && (
                        <DatePicker
                          clearable={clearable}
                          value={parseDate(application[key])}
                          onChange={(date) => this.handleDateChange(date, key)}
                          InputProps={{
                            classes: {
                              root: cn.datePicker,
                            }
                          }}
                        />
                      )}
                      {key === 'service_agency' && (
                        <Select
                          value={application['service_agency_id'] || ''}
                          onChange={this.handleServiceAgencyChange}
                          className={cn.select}
                        >
                          {serviceAgencies.map(agency => (
                            <MenuItem key={agency.id} value={agency.id}>{agency.name}</MenuItem>
                          ))}
                        </Select>
                      )}
                      {key === 'insurance_agency' && (
                        <Select
                          value={application['insurance_agency_id'] || ''}
                          onChange={this.handleInsuranceAgencyChange}
                          className={cn.select}
                        >
                          {insuranceAgencies.map(agency => (
                            <MenuItem key={agency.id} value={agency.id}>{agency.name}</MenuItem>
                          ))}
                        </Select>
                      )}
                    </div>
                  ) : (
                    <div className={cn.value}>{application[key]}</div>
                  )}
                </div>
              )
            })
          }
        </div>
        <div className={cn.buttons}>
          <Button onClick={this.handleSave} variant="contained" color="primary" className={cn.button}>
            Save
          </Button>
          <Button onClick={onClose} variant="outlined" color="primary" className={cn.button}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }
}
